<template>
  <div>
    <div class="card">
      <div class="card-header"><h4>Cadastrar Vídeo</h4></div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-4">
            <label for="titulo">Título</label>
            <input
              id="titulo"
              type="text"
              class="form-control"
              placeholder="Digite um titulo:"
              v-model="state.titulo"
            />
          </div>
          <div class="col-md-2">
            <label for="status">Status</label>
            <select v-model="state.status" class="form-select">
              <option value="ATIVO">Ativo</option>
              <option value="INATIVO">Inativo</option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <label for="url">URL</label>
            <input
              id="url"
              type="text"
              class="form-control"
              placeholder="Digite um url:"
              v-model="state.url"
            />
          </div>
        </div>
        <div class="btns_right">
          <button @click="salvarVideo" type="button" class="btn_save">
            Salvar
          </button>
          <router-link to="/admin/servicos">
            <button type="button" class="btn_cancel">Cancelar</button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import services from "../../services";
import { useStorage } from "vue3-storage";
export default {
  setup() {
    const router = useRouter();
    const storage = useStorage();
    var token = storage.getStorageSync("token");
    const state = reactive({
      id: "",
      titulo: "",
      link: "",
      status: "ATIVO",
    });
    onMounted(() => {
      if (router.currentRoute._value.params.id != undefined) {
        fetchVideo();
      }
    });
    async function fetchVideo() {
      try {
        const { data } = await services.videos.getById({
          id: router.currentRoute._value.params.id,
          token,
        });
        state.id = data.id;
        state.titulo = data.titulo;
        state.url = data.url;
        state.status = data.status;
      } catch (error) {
        void error;
      }
    }
    async function salvarVideo() {
      let dados = {
        titulo: state.titulo,
        url: state.url,
        status: state.status,
        token,
      };

      if (!state.id) {
        try {
          await services.videos.save(dados, token);
          router.push({ name: "Videos" });
        } catch (error) {
        void error;
      }
      } else {
        dados.id = state.id;
        try {
          await services.videos.update(dados, token);
          router.push({ name: "Videos" });
        } catch (error) {
        void error;
      }
      }
    }
    async function adicionarImagem(event) {
      var img = event.target.files[0];
      var objImagem = new Object();
      objImagem.file = img;
      objImagem.imagem = URL.createObjectURL(img);
      state.imagem = objImagem;
    }
    async function removerImagem() {
      state.imagem = {};
      document.querySelector('input[type="file"]').value = null;
    }
    return {
      salvarVideo,
      removerImagem,
      adicionarImagem,
      router,
      state,
    };
  },
};
</script>
<style scoped>
h4 {
  color: #000;
}
label {
  color: #000;
  font-size: 12pt;
  margin-bottom: 0;
  margin-top: 5px;
}
input {
  border: solid 1px #000;
}
input:focus {
  border: solid 1px #8b0000;
}
select {
  border: solid 1px #000;
}
select:focus {
  border: solid 1px #8b0000;
}
textarea {
  resize: none;
  border: solid 1px #000;
}
textarea:focus {
  border: solid 1px #8b0000;
}
.btns_right {
  text-align: right;
  margin-top: 5rem;
}
.btn_save {
  padding: 5px;
  width: 100px;
  background: #00a000;
  border: solid 2px #000;
  border-radius: 5px;
  transition: 0.2s;
}
.btn_save:hover {
  background: #008000;
}
.btn_cancel {
  padding: 5px;
  width: 100px;
  background: #c4342d;
  border: solid 2px #000;
  border-radius: 5px;
  margin-left: 10px;
  transition: 0.2s;
}
.btn_cancel:hover {
  background: #8f0303;
}
.imagem {
  width: 100%;
  object-fit: cover;
  margin-top: 1rem;
}
.btn_deletar_imagem {
  width: 25px;
  height: 25px;
  margin-left: 3px;
  background: #8b0000;
  color: #fff;
  border: solid 1px #8b0000;
  border-radius: 5px;
  transition: 0.3s;
  margin-top: 1rem;
}
.btn_deletar_imagem:hover {
  background: rgb(228, 0, 0);
  color: #fff;
  border: solid 1px rgb(228, 0, 0);
}
.card {
  border: solid 2px #000;
  border-radius: 10px;
  background-color: #fff;
}
</style>